import React from "react";
import { isApiFileUrl, resolveFileUrl } from "../../utils/fileUrl";

type AppImageProps = Omit<
  React.ImgHTMLAttributes<HTMLImageElement>,
  "src" | "crossOrigin"
> & {
  src?: string | null;
};

/**
 * `<img>` wrapper that resolves /api/files/{guid} URLs against the runtime
 * backend host and attaches `crossOrigin="use-credentials"` when the resolved
 * URL points at our API. Required for the bpreven.auth HttpOnly cookie to
 * ride along on cross-origin image requests; the browser strips credentials
 * from `<img>` requests otherwise.
 */
const AppImage: React.FC<AppImageProps> = ({ src, ...rest }) => {
  const resolved = resolveFileUrl(src);
  const crossOrigin = isApiFileUrl(resolved) ? "use-credentials" : undefined;
  return <img src={resolved} crossOrigin={crossOrigin} {...rest} />;
};

export default AppImage;
